import { AxiosError } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { Staff, StaffFilters } from '@/types/person';
import RepositoryResponse from '@/types/repositoryResponse';
import ajax from '@/utils/ajax';
import defaultRepositoryError from '@/utils/defaultRepositoryError';

export const staffRepository = {
  async getStaffList({
    host,
    params
  }: {
    host: string;
    params: StaffFilters;
  }): Promise<RepositoryResponse<Staff[]>> {
    try {
      const path = '/api/dugout/staff/';
      const { data } = await ajax.get({
        url: `${host}${path}`,
        params: {
          ...params
        }
      });

      return {
        data,
        isError: false
      };
    } catch (error) {
      return defaultRepositoryError(error as AxiosError, 'Failed to get staff.');
    }
  }
};

const StaffRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async getStaffList(params: StaffFilters): Promise<RepositoryResponse<Staff[]>> {
      return staffRepository.getStaffList({ host, params });
    }
  };
};

export default StaffRepository;
